import BaseDialog from "@/components/BaseDialog";
import BaseDrawer from "@/components/BaseDrawer";



// 提交 -项目 提示
export function submitTipModal({ props, cbs,slots }) {
    return new BaseDialog({
        component: ()=>import('./submitTipModal.vue'),
        options: {
            width: '500px',
            title: '提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            wrapperClosable:false,
            showClose:false,
            withHeader:false,
        },
        props,
        cbs,
        slots,
    })
}

// 无权限项目提示
export function noAuthModal({ props, cbs,slots, on }) {
    return new BaseDialog({
        component: ()=>import('./noAuthModal.vue'),
        options: {
            width: '800px',
            title: '项目无权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            wrapperClosable:false,
            // showClose:false,
            withHeader:false,
        },
        props,
        cbs,
        slots,
        on
    })
}

// 批量录入项目
export function batchProjectModal({ props, cbs,slots, on }) {
    return new BaseDialog({
        component: ()=>import('./batchProjectModal.vue'),
        options: {
            width: '800px',
            title: '批量录入',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            wrapperClosable:false,
            // showClose:false,
            withHeader:false,
        },
        props,
        cbs,
        slots,
        on
    })
}
